/**
 * Helper module for persistent Group and Facility dropdown selections per component.
 */

export const getPersistentGroup = (componentKey, options = [], fallback = null) => {
  try {
    const saved = localStorage.getItem(`persistent_group_${componentKey}`);
    if (!saved) return fallback;

    let parsed = saved;
    try {
      parsed = JSON.parse(saved);
    } catch (e) {
      parsed = saved;
    }

    const savedVal = typeof parsed === 'object' && parsed !== null ? (parsed.value ?? parsed.id) : parsed;

    if (Array.isArray(options) && options.length > 0) {
      const matched = options.find(opt => {
        if (!opt) return false;
        const optVal = typeof opt === 'object' ? (opt.value ?? opt.id) : opt;
        return String(optVal) === String(savedVal);
      });
      if (matched) return matched;
    }

    if (typeof parsed === 'object' && parsed !== null) return parsed;
    return fallback;
  } catch (e) {
    return fallback;
  }
};

export const setPersistentGroup = (componentKey, group) => {
  try {
    if (group === null || group === undefined) {
      localStorage.removeItem(`persistent_group_${componentKey}`);
      return;
    }
    if (typeof group === 'object') {
      localStorage.setItem(`persistent_group_${componentKey}`, JSON.stringify(group));
    } else {
      localStorage.setItem(`persistent_group_${componentKey}`, String(group));
    }
  } catch (e) {}
};

export const getPersistentFacility = (componentKey, options = [], fallback = null) => {
  try {
    const saved = localStorage.getItem(`persistent_facility_${componentKey}`);
    if (!saved) return fallback;

    let parsed = saved;
    try {
      parsed = JSON.parse(saved);
    } catch (e) {
      parsed = saved;
    }

    const savedVal = typeof parsed === 'object' && parsed !== null ? (parsed.value ?? parsed.id ?? parsed.facility_id) : parsed;

    if (Array.isArray(options) && options.length > 0) {
      const matched = options.find(opt => {
        if (!opt) return false;
        const optVal = typeof opt === 'object' ? (opt.value ?? opt.id ?? opt.facility_id) : opt;
        return String(optVal) === String(savedVal);
      });
      if (matched) return matched;
    }

    if (typeof parsed === 'object' && parsed !== null) return parsed;
    return fallback;
  } catch (e) {
    return fallback;
  }
};

export const setPersistentFacility = (componentKey, facility) => {
  try {
    if (facility === null || facility === undefined) {
      localStorage.removeItem(`persistent_facility_${componentKey}`);
      return;
    }
    if (typeof facility === 'object') {
      localStorage.setItem(`persistent_facility_${componentKey}`, JSON.stringify(facility));
    } else {
      localStorage.setItem(`persistent_facility_${componentKey}`, String(facility));
    }
  } catch (e) {}
};
